import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { coreSelectors } from './redux/CoreSlice/core';

/**
 * Get the page title based on the current pathname
 * @param {string} pathname - Current route path
 * @param {string} tenantCode - Current tenant code
 * @returns {string} Page title
 */
const getPageTitle = (pathname, tenantCode) => {
    // Login page
    if (pathname.startsWith('/auth/login')) {
        return tenantCode ? `Blueprint Login - ${tenantCode}` : 'Blueprint Login';
    }

    // SAML callback
    if (pathname.startsWith('/auth/saml')) {
        return 'SSO Login';
    }

    // Forgot password
    if (pathname.startsWith('/auth/forgot-password')) {
        return 'Forgot Password';
    }

    // Change password
    if (pathname.startsWith('/auth/change-password')) {
        return 'Change Password';
    }

    // Force change password
    if (pathname.startsWith('/auth/force-change-password')) {
        return 'Change Password';
    }

    // MFA registration
    if (pathname.startsWith('/auth/register')) {
        return 'MFA Setup';
    }

    // MFA settings
    if (pathname.startsWith('/auth/mfa-settings')) {
        return 'MFA Settings';
    }

    // Other auth pages
    if (pathname.startsWith('/auth/')) {
        return 'Blueprint';
    }

    // Tenant admin pages
    if (pathname.startsWith('/tenants/list/tenants') || pathname.match(/^\/tenants\/[^/]+$/)) {
        return 'Tenant Admin';
    }

    // User pages (under tenants or users routes)
    if (pathname.includes('/list/users') || pathname.match(/\/users\/[^/]+$/)) {
        return 'User Admin';
    }

    // Invite pages
    if (pathname.includes('/list/invites') || pathname.includes('/invite')) {
        return 'Invite Admin';
    }

    // Default
    return 'Blueprint';
};

const TabIcon = () => {
    const tenantCode = useSelector(coreSelectors.tenantCode);
    const { pathname } = useLocation();

    const pageTitle = getPageTitle(pathname, tenantCode);

    // Update document title directly on route changes
    useEffect(() => {
        document.title = pageTitle;
    }, [pageTitle]);

    return (
        <Helmet>
            {tenantCode && (
                <>
                    <link rel="icon" href={`/getIcon?code=${tenantCode}`} onError={event => {
                        event.target.href = '';
                        event.onerror = null;
                    }} />
                    <link rel="apple-touch-icon" href={`/getIcon?code=${tenantCode}`} onError={event => {
                        event.target.href = '';
                        event.onerror = null;
                    }} />
                </>
            )}
        </Helmet>
    );
};

export default TabIcon;
